import { useState, useEffect, useContext, useRef, useMemo, useCallback } from 'react'
import callContext from '@/pages/crm/callCenter/callManage/callManageContext'
import { Pagination, Checkbox, Spin, message, Space } from 'antd'
import { debounce, isArray, uniqueId } from 'lodash-es'
import {fetchCallListCount, getCallPage, getlistByCall} from '@/services/callCenter'
import {
  dispatchStatusColor,
  getNumberUnit,
  deleteBlankObj,
} from '@/pages/crm/callCenter/callManage/utils'
import { useDebounceFn, useSetState } from 'ahooks'
import { Scrollbars } from 'react-custom-scrollbars'
import styles from '../../index.module.less'
import { LoadingOutlined } from '@ant-design/icons'

function MainLeft(props: any) {
  const { updateCallManageState, callManageState } = useContext(callContext)
  const { detailParameter, callFormData, currentPage, callList, refreshList, checkClueList } =
    callManageState
  const { width = '360px' } = props
  const [loading, setLoading] = useState(false) //列表加载
  const [loadingMore, setLoadingMore] = useState(false) //列表加载
  const [noMore, setNoMore] = useState(false) //列表加载
  const [total, setTotal] = useState(0) //列表总数
  const [pageSize, setpageSize] = useState(50)
  const scrollRef = useRef<any>()
  const contentRef = useRef<any>()
  const loadingRef = useRef<any>(false)

  const [state, setState] = useSetState({
    totalLoading: false,
  })
  const requestKey = useRef<any>('')
  const totalRequestKey = useRef<any>('')

  useEffect(() => {
    loadingRef.current = false
    run()
    scrollRef.current.scrollTop(0)
  }, [refreshList])
  const { run } = useDebounceFn(
    () => {
      fetchData()
      // fetchTotal()
    },
    { wait: 100 }
  )

  const covertParams = () => {
    let _formData = {
      ...callFormData,
    }
    if(callFormData.statusList !== '') _formData.status = ''
    if (['ALL', 'FG', 'GH'].includes(callFormData.status)) {
      _formData.status = ''
    }
    _formData = deleteBlankObj(_formData)
    if (_formData.signTime) {
      // 报名时间
      _formData.signStartTime = _formData.signTime[0].format('YYYY-MM-DD HH:mm:ss')
      _formData.signEndTime = _formData.signTime[1].format('YYYY-MM-DD HH:mm:ss')
      delete _formData.signTime
    }
    if (_formData.dispatchTime) {
      // 派单时间
      _formData.dispatchStartTime = _formData.dispatchTime[0].format('YYYY-MM-DD HH:mm:ss')
      _formData.dispatchEndTime = _formData.dispatchTime[1].format('YYYY-MM-DD HH:mm:ss')
      delete _formData.dispatchTime
    }
    if (_formData.lastFollowTime) {
      // 跟进时间
      _formData.lastFollowTimeStart = _formData.lastFollowTime[0].format('YYYY-MM-DD HH:mm:ss')
      _formData.lastFollowTimeEnd = _formData.lastFollowTime[1].format('YYYY-MM-DD HH:mm:ss')
      delete _formData.lastFollowTime
    }
    if (_formData.lastCallTime) {
      // 通话时间
      _formData.lastCallTimeStart = _formData.lastCallTime[0].format('YYYY-MM-DD HH:mm:ss')
      _formData.lastCallTimeEnd = _formData.lastCallTime[1].format('YYYY-MM-DD HH:mm:ss')
      delete _formData.lastCallTime
    }
    if (_formData.client_source) delete _formData.client_source //删除无需传输的值
    // if (_formData.status && !isArray(_formData.status)) {
    //   // 线索状态
    //   _formData.status = _formData.status.split(',')
    // }

    // 高级筛选派单状态没值则删除派单状态
    if (_formData.dispatchStatus && !_formData.dispatchStatus.length)
      delete _formData.dispatchStatus
    // 高级筛选派单状态有值则覆盖线索状态
    if (_formData.dispatchStatus) {
      _formData.status = _formData.dispatchStatus
      delete _formData.dispatchStatus
    }
    // 已回单是否有值，有则转换为Boolean类型
    if (_formData.isReturn + '' === '0' || _formData.isReturn) {
      _formData.isReturn = !!_formData.isReturn
    }
    // 已签单是否有值，有则转换为Boolean类型
    if (_formData.isSign + '' === '0' || _formData.isSign) {
      _formData.isSign = !!_formData.isSign
    }
    if (_formData.workNumberList || _formData.deptCode) {
      _formData.relativesRequest = {
        ucenterUserIds: _formData.workNumberList,
        deptId: _formData.deptCode,
        dutyType: 'subsidiary.seatman',
      }
      delete _formData.workNumberList;
      delete _formData.deptCode;
    }
    return _formData
  }
  // 请求列表数据
  const fetchData = ({ current } = {}) => {
    if (loadingRef.current) return
    loadingRef.current = true

    if (current > 1) {
      setLoadingMore(true)
    } else {
      setLoading(true)
    }

    const _formData = covertParams()
    const _current = current || currentPage
    const _requestKey = uniqueId('request')
    console.log('search_formData', _formData)
    requestKey.current = _requestKey
    getCallPage(_current, pageSize, {
      ..._formData,
      // lastClueId: _current <= 1 ? void 0 : callList[callList.length - 1]?.clueId,
    })
      .then((res: any) => {
        setLoading(false)
        const list = res.list || []
        const count = res.count || 0
        if (_requestKey !== requestKey.current) return
        // setTotal(res?.count)
        if (list.length > 0 && _current <= 1) {
          updateCallManageState({
            detailParameter: list[0],
          })
        }
        if (list.length === 0) {
          clearCache()
        }
        // console.log('callList', _current, callList)
        // if (_current > 1) {
        //   list = [...callList, ...list]
        // }

        if (!res.length) {
          setNoMore(true)
        }
        setTotal(count)
        updateCallManageState({
          callList: list,
        })
      })
      .finally(() => {
        if (_requestKey === requestKey.current) {
          setLoading(false)
        }
        setLoadingMore(false)
        loadingRef.current = false
      })
  }

  const fetchMore = useCallback(
    debounce(() => {
      if (loadingRef.current) return
      const nextPage = currentPage + 1
      updateCallManageState({ currentPage: nextPage })
      fetchData({ current: nextPage })
    }, 100),
    [currentPage, callList]
  )

  const fetchTotal = () => {
    const _formData = covertParams()
    const _key = uniqueId('total_')
    totalRequestKey.current = _key
    setState({
      totalLoading: true,
    })
    fetchCallListCount(_formData)
      .then(res => {
        if (totalRequestKey.current === _key) setTotal(res)
      })
      .finally(() => {
        if (totalRequestKey.current === _key) {
          setState({
            totalLoading: false,
          })
        }
      })
  }

  // const onScroll = values => {
  //   const totalHeight = values.scrollTop + values.clientHeight
  //   const height = contentRef.current.getBoundingClientRect().height
  //
  //   if (height - totalHeight < values.clientHeight * 0.3) {
  //     fetchMore()
  //   }
  // }

  const onScrollStop = () => {}

  // 清空详情数据
  const clearCache = () => {
    updateCallManageState({
      callDetails: {},
      detailParameter: {},
      TSDetailId: 0,
    })
  }

  // 点击行
  const onclickItem = (data: any) => {
    if (detailParameter?.id === data?.id) return
    updateCallManageState({
      detailParameter: data,
    })
  }

  const listItem = (data: any, i: any, state: any) => {
    return (
      <div
        className={`${styles.listItem} ${state ? styles.checkedItem : ''}`}
        key={data.id}
        onClick={e => {
          onclickItem(data)
        }}
      >
        <div className={styles.listRow}>
          <div className={styles.rowLeft}>
            <Checkbox
              className={styles.rowCheckbox}
              value={data.id}
              onClick={(e: any) => e.stopPropagation()}
            />
            <div className={styles.rowId}>ID:{data.id}</div>
          </div>
          <div
            className={styles.rowTag}
            style={{
              color: dispatchStatusColor({ value: data.statusName, isText: true }),
              borderColor: dispatchStatusColor({ value: data.statusName }),
              background: dispatchStatusColor({ value: data.statusName, isBackground: true }),
            }}
          >
            {data.statusName}
          </div>
        </div>
        <div className={styles.rowContent}>
          <div className={styles.rowContentName}>{data.phone || '--'}</div>
          <div className={styles.rowContentName}>{data.name || '--'}</div>
        </div>
        {data.isDial ? (
          <div className={styles.listRow} style={{ paddingLeft: '38px' }}>
            <div className={styles.rowCall}>
              接通/拨打：{data.successCount || '0'}/{data.totalCount || '0'}
            </div>
          </div>
        ) : (
          <div className={`${styles.listRow}`} style={{ paddingLeft: '38px' }}>
            <div className={`${styles.rowCall}`}>未拨打</div>
          </div>
        )}
      </div>
    )
  }
  const totalRender = (total: any) => <div>共{getNumberUnit(total, '', 2).numberValue}条</div>

  const onPageChange = (v: any) => {
    updateCallManageState({ currentPage: v })
    updateCallManageState({
      checkClueList: [],
      refreshList: !refreshList,
    })
  } // 页数更新
  return (
    <div className={styles.mainLeft} style={{ width: width }}>
      <Spin tip="Loading" size="small" spinning={loading}>
        <div
          // style={{height: 'calc(100vh - 109px - 60px)'}}
          style={{ height: 'calc(100vh - 295px)' }}
        >
          <Scrollbars
            // height={'calc(100vh - 109px - 60px)'}
            ref={scrollRef}
            renderTrackHorizontal={() => <div></div>}
            // thumbSize={4}
            // onScrollFrame={onScroll}
            onScrollStop={onScrollStop}
          >
            <div className={styles.scroller} ref={contentRef}>
              <Checkbox.Group
                style={{width: '100%'}}
                value={checkClueList}
                onChange={(value: any[]) => {
                  updateCallManageState({
                    checkClueList: value,
                  })
                }}
              >
                <div className={styles.listItemBox}>
                  {isArray(callList)
                    ? callList.map((d: any, i: any) => {
                        const state = detailParameter.id == d.id
                        return listItem(d, i, state)
                      })
                    : null}
                </div>
              </Checkbox.Group>
            </div>
            {/*<div className={styles.listState}>*/}
            {/*  {noMore && !loadingMore ? '没有更多了' : ''}*/}
            {/*  {loadingMore ? '加载中...' : ''}*/}
            {/*</div>*/}
          </Scrollbars>
        </div>
      </Spin>
      <div
          className={styles.paging}
          onClick={() => {
            return new Promise(resolve => {
              resolve({})
              // message.error('test 123')
            })
          }}
      >
        <Pagination
            style={{margin: '0 10px 0 auto'}}
            current={currentPage}
            pageSize={pageSize}
            onChange={onPageChange}
            showTotal={totalRender}
            size="small"
            total={total}
            showLessItems={true}
            showSizeChanger={true}
            showQuickJumper={false}
        />
        {/*<Space>共{state.totalLoading ? <LoadingOutlined /> : total}条</Space>*/}
      </div>
    </div>
  )
}

export default MainLeft
